<template>
	<div class="o-container o-container--thin">
		<update-details-form
			:user="user"
			:submit="onSubmit"
		/>
	</div>
</template>

<script>
	import UpdateDetailsForm from '../forms/UpdateDetailsForm.vue';
	import { mapState } from 'vuex';

	export default {
    components: {
      UpdateDetailsForm
    },
    computed: {
      ...mapState('user', {
        user: state => state.user
      })
    },
    methods: {
      onSubmit(userData) {

        return this.$store.dispatch('user/UPDATE_USER_DETAILS', this.sanitizeInput(userData)).then(() => {
          this.$router.push({
            name: 'myAccount',
            params: {
              message: {
                type: 'success',
                value: 'Your details were successfully updated.'
              }
            }
          });
        });
      },
      sanitizeInput(data) {

        Object.keys(data).forEach(function (key) {
          if (data[key]) {
            data[key] = data[key].replace(/<.+?>/g, '');
          } else {
            data[key] = '';
          }
        });
        return data;
      }
    }
  };
</script>

<style lang="scss" scoped>

</style>
